import { Component, OnInit } from '@angular/core';
import { Empty_LetterRequestCustomer_List_Interface, LetterRequestCustomer_List_Interface } from 'src/app/Interface/LetterRequestCustomer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { LetterRequestCustomerScheduleServiceService } from 'src/app/Service/Letter/LetterRequestCustomerScheduleService.service';

import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-ScheduleLetterList',
  templateUrl: './ScheduleLetterList.component.html',
  styleUrls: ['./ScheduleLetterList.component.css']
})
export class ScheduleLetterListComponent implements OnInit {
  BaseUrl1 = environment.BaseUrl + "Letterrequestcustomerprint/Schedule?id="
  BaseUrl2 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?id="
  BaseUrl3 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?id="

  constructor(
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private LetterRequestCustomerSchedule_Service: LetterRequestCustomerScheduleServiceService,
    private Nav_Service: NavService,
    private Alertify_Service:AlertifyService,
  ) { }

  ngOnInit() {
    this.BaseUrl1 = environment.BaseUrl + "Letterrequestcustomerprint/Schedule1?id="
    this.BaseUrl2 = environment.BaseUrl + "Letterrequestcustomerprint/DeviceBehfa?id="
    this.BaseUrl3=environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
    
    this.Nav_Service.CheckValidPage(2210).subscribe(
      data => {
        this.ReadData_Letter()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }


  //#region Read Data
  page=0
  DataList_LetterRequestCustomer:Array<LetterRequestCustomer_List_Interface>=[]
  Procssing_LetterRequestCustomer:boolean=false
  Filter_CustomerName:string=''
  Filter_LetterCode:string=''
  ReadData_Letter(){
    this.Procssing_LetterRequestCustomer=true
    this.LetterRequestCustomerSchedule_Service.GetData().subscribe(
      data=>{
        this.DataList_LetterRequestCustomer=data
        this.Procssing_LetterRequestCustomer=false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }
  //#endregion

  Form_Switcher:string="List"
  Selected_DataList_LetterRequestCustomer:LetterRequestCustomer_List_Interface=Empty_LetterRequestCustomer_List_Interface()
  On_Set_Form_Switcher(input:string,record:LetterRequestCustomer_List_Interface)
  {
    this.Form_Switcher=input
    this.Selected_DataList_LetterRequestCustomer=record
  }

  On_Back_Form_Switcher(){
    this.Form_Switcher="List"
    this.Selected_DataList_LetterRequestCustomer=Empty_LetterRequestCustomer_List_Interface()
  }


  SwichActivityVisible(item: LetterRequestCustomer_List_Interface) {

    this.LetterRequestCustomer_Service.SwichActivityVisible(Number(item.code)).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("تغییرات اعمال شد")
          item.activityVisible=!item.activityVisible
        }
      )
  }

  
  SwichActivityDevice(item: LetterRequestCustomer_List_Interface) {

    this.LetterRequestCustomer_Service.SwichActivityDsc(Number(item.code)).subscribe(
        data => {
          this.Alertify_Service.SuccessMessage("تغییرات اعمال شد")
          item.dscVisible=!item.dscVisible
        }
      )
  }


}
